import $ from 'jquery';
import AOS from 'aos';
import 'aos/dist/aos.css';

$(window).on('load ', () => {
  AOS.init({
    once: true,
    duration: 1000
  });
});
